import { Outlet } from "react-router-dom";
import CommonNavbar from "./Component/Navbars/CommonNavbar";
import Footer from "./Component/Footer/Footer";

function App() {
  return (
    <>
    <CommonNavbar/>
    <Outlet/>
    <Footer/>
    </>
  );
}

export default App;
